// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fi{vertical-align:middle}.fi.sm{font-size:.75rem}.fi.md{font-size:1.075rem}.fi.lg{font-size:1.275rem}.fi.xlg{font-size:1.55rem}.fi:before{line-height:1.563rem!important;float:right!important}", ""]);
// Exports
module.exports = exports;
